import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import Breadcrumbs from "./Breadcrumbs";
import MobileAppBanner from "./MobileAppBanner";
import PWAInstallPrompt from "./PWAInstallPrompt";
import AiHelpButton from "./AiHelpButton";
import useHeartbeat from "../lib/useHeartbeat";
import useScrollRestoration from "../lib/useScrollRestoration";
import useAuctionAlerts from "../lib/useAuctionAlerts";

export default function Layout() {
  // Anonymous live-visitor heartbeat so admins can see who is on the site
  useHeartbeat();
  // Restore scroll position when the user navigates back, reset to top on push.
  useScrollRestoration();
  // Fire browser notifications for auctions the user has bid on: 10-min warning + outbid.
  useAuctionAlerts();
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <Breadcrumbs />
      <main className="flex-1 pb-20 md:pb-0">
        <Outlet />
      </main>
      <Footer />
      <MobileAppBanner />
      <PWAInstallPrompt />
      <AiHelpButton />
    </div>
  );
}
